import React, { useState, useEffect } from "react";
import {
  getAllCategories,
  addCategory,
  updateCategory,
  deleteCategory,
} from "../services/CategoryService"; 
import style from './index.module.css'; 

function CategoryList() {
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [editingCategoryId, setEditingCategoryId] = useState(null);
  const [editText, setEditText] = useState("");

  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    const data = await getAllCategories(); 
    setCategories(data);
  };

  const handleAddCategory = async () => {
    if (!newCategory.trim()) return; 
    await addCategory({ name: newCategory });
    setNewCategory(""); 
    loadCategories();
  };

  const handleUpdateCategory = async (id) => {
    if (!editText.trim()) return;
    await updateCategory(id, { name: editText }); 
    setEditingCategoryId(null); 
    loadCategories();
  };

  const handleDeleteCategory = async (id) => {
    if (window.confirm("Bu kateqoriyanı silmək istədiyinizə əminsiniz?")) {
      await deleteCategory(id); 
      loadCategories(); 
    }
  };

  return (
    <div className={style.cat}>
      <div className="container mt-5">
        <h2 className="text-center mb-4">📂 Categories</h2>

        <div className="d-flex mb-4">
          <input
            type="text"
            className="form-control me-2"
            placeholder="New Category..."
            value={newCategory}
            onChange={(e) => setNewCategory(e.target.value)} 
          />
          <button
            onClick={handleAddCategory} 
            className="btn btn-primary"
            disabled={!newCategory.trim()} 
          >
            ➕ Add
          </button>
        </div>

        <div className="row row-cols-1 row-cols-md-2 g-4">
          {categories.map((category) => (
            <div className="col" key={category.id}>
              <div className="card shadow-sm">
                <div className="card-body">
                  {editingCategoryId === category.id ? (
                    <input
                      type="text"
                      className="form-control"
                      value={editText}
                      onChange={(e) => setEditText(e.target.value)} 
                    />
                  ) : (
                    <h5 className="card-title">{category.name}</h5>
                  )}
                  <div className="d-flex justify-content-between mt-3">
                    {editingCategoryId === category.id ? (
                      <button
                        onClick={() => handleUpdateCategory(category.id)} 
                        className="btn btn-success"
                      >
                        ✅ Save
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          setEditingCategoryId(category.id); 
                          setEditText(category.name); 
                        }}
                        className="btn btn-warning"
                      >
                        ✏️ Edit
                      </button>
                    )}
                    <button
                      onClick={() => handleDeleteCategory(category.id)} 
                      className="btn btn-danger"
                    >
                      🗑️ Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CategoryList;
